module.exports = __webpack_public_path__ + "static/media/planning6@2x.55894df3.png";